import React from 'react';

import { fundsOriginList } from 'const/fundsOrigin';
import { professionalStatusList } from 'const/professionalStatus';
import { View } from '@coinscrap/webapp-core';
import InputLabel from 'components/InputLabel/InputLabel';



export const AdditionalDataInputs = ({
	professionalStatus,
	setProfessionalStatus,
	fundsOrigin,
	setFundsOrigin,
}) => {
	return (
		<>
			<View inputFreeRowSt>
				<InputLabel
					style={{ marginTop: -20 }}
					value={professionalStatus || 0}
					onChange={(e) => {
						setProfessionalStatus(e.target.value);
					}}
					label={'Situación laboral'}
					type="select"
					selectOptions={professionalStatusList.map((item) => {
						return {
							label: item.VALUE,
							value: item.NAME,
						};
					})}
				/>
			</View>

			<View inputFreeRowSt>
				<InputLabel
					value={fundsOrigin || 0}
					onChange={(e) => {
						setFundsOrigin(e.target.value);
					}}
					label={'¿De dónde provienen los fondos?'}
					type="select"
					selectOptions={fundsOriginList.map((item) => {
						return {
							label: item.NAME,
							value: item.VALUE,
						};
					})}
				/>
			</View>
		</>
	);
};
